import { elektraAppQueryOptions } from '@connected/elektra-sdk/queries/query-options';
import { useSuspenseQuery } from '@tanstack/react-query';

export type UseObservationLogsProps = {
    electricalProjectVersionId: string;
};

export function useObservationLogs(props: UseObservationLogsProps) {
    const { electricalProjectVersionId } = props;
    if (!electricalProjectVersionId) {
        throw new Error('electricalProjectVersionId is required');
    }

    const observationLogs = useSuspenseQuery(elektraAppQueryOptions.project.inspection.conclusion.observationLogsListOptions({
        electricalProjectVersionId,
    }));

    return {
        data: {
            items: observationLogs.data.Observations?.filter(x => x?.IsDeleted === false) ?? [],
            count: observationLogs.data.Observations?.filter(x => x?.IsDeleted === false).length ?? 0,
        },
        isLoading: observationLogs.isLoading,
        isError: observationLogs.isError,
        error: observationLogs.error,
    };
}
